// extracted by css-extract-rspack-plugin
export default {"container":"Container__container--nU82h"};